import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-market-info',
  templateUrl: './market-info.component.html',
  styleUrls: ['./market-info.component.scss'],
})
export class MarketInfoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
